import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ApiKeyInput } from '../../entities/apiKey/apiKey';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';

/**
 * The apiKeys service.
 */
@Injectable()
export class ApiKeysService {
  constructor(
    private apolloService: ApolloService,
    private apollo: Apollo,
    ) {}

  /**
   * updates a mode
   * @param apiKeyInput apiKey Input
   * @param callback method
   */
  public updateApiKey(apiKeyInput: ApiKeyInput, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_API_KEY_MUTATION,
      {
        apiKeyInput,
      },
      callback
    );
  }

  /**
   * creates a apiKey
   * @param apiKeyInput ApiKey input
   * @param callback method
   */
  public createApiKey(apiKeyInput: ApiKeyInput, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.CREATE_API_KEY_MUTATION,
      {
        apiKeyInput,
      },
      callback
    );
  }

  /**
   * deletes a apiKey
   * @param apiKeyId ApiKey Id
   * @param callback method
   */
  public deleteApiKey(apiKeyId: string, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.DELETE_API_KEY_MUTATION,
      {
        apiKeyId,
      },
      callback
    );
  }
}
